import CryptoJS from "crypto-js";

export function formatLoginData({ party_username, party_password }) {
  const hashedPassword = CryptoJS.MD5(party_password.trim()).toString();
  console.log("hashpassword-", hashedPassword);
  console.log("user name-", party_username.trim());

  return [
    {
      name: "",
      tables: {
        parameter: [
          {
            branchid: "1",
            change_pwd: "N",
            pwd: hashedPassword,
            username: party_username.trim(),
          },
        ],
      },
    },
  ];
}
export function encryptAuthPhrase() {
  const key = CryptoJS.enc.Utf8.parse("12345678901234567890123456789012");
  const iv = CryptoJS.enc.Utf8.parse("1234567890123456");
  const encrypted = CryptoJS.AES.encrypt(
    "d1f7b3c9-ec7f-4a13-b72b-0c9a7f3a2de5",
    key,
    { iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
  );
  return encrypted.ciphertext.toString(CryptoJS.enc.Hex);
}
